import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'first',
})
export class FirstPipe implements PipeTransform {
  transform(items: any[], property?: string): any {
    if (!items) return null;
    if (items.length <= 0) return null;

    if (property) return items[0][property];
    return items[0];
  }
}
